export enum taxAccordeonDisplay {
    taxAccordeonDisplay = 'accordions'
}

